import type Teacher from '@whizz/api-client/dist/@types/model/Teacher';
import { useIdentity } from '@whizz/react-identity';


export const useCleverIntegration = () => {
  const { me } = useIdentity();
  const isClever = !!(me as Teacher)?.cleverId;
  return [ isClever ];
};
